

















import { defineComponent, ref } from "@nuxtjs/composition-api";

export default defineComponent({
  name: "ElementsButtons",
  props: {
    tag: {
      type: String,
      default: "div",
    },
    node: {
      type: String,
      default: "div",
    },
    attr: {
      type: Object,
      default: () => {},
    },
    children: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const text = ref("");

    const pb = {children: props.children};
    text.value =
      pb.children[0]?.["child"][0]["child"][0]["child"][0]?.["text"];

    return {
      text,
    };
  },
});
